import * as React from 'react';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef((props, ref) => {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AlertCustom = (props) => {
    const { message, children } = props;
    return (
        <Alert {...props}>
            {message && message}
            {children && children}
        </Alert>
    )
}

export default AlertCustom;